import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import { MdMenu } from "react-icons/md";
import userRoutes from "routes/userRoutes";
import { authService } from "services/authService";
import NotificationsPage from "views/notifications";

export default function UserLayout() {
  const currentRole = authService.getStoredUser()?.role;
  const defaultPath =
    currentRole === "TRAINER" || currentRole === "TEACHER"
      ? "/user/sessions"
      : "/user/schedule";
  const [open, setOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) setOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getRoutes = (routes: RoutesType[]) =>
    routes.map((prop, key) =>
      prop.layout === "/user" ? (
        <Route path={`/${prop.path}`} element={prop.component} key={key} />
      ) : null
    );

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar
        open={open}
        collapsed={collapsed}
        onClose={() => setOpen(false)}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        routes={userRoutes}
      />
      <div className="h-full w-full bg-canvas">
        <main
          className={`mx-[12px] h-full flex-none transition-all duration-300 md:pr-2 ${
            collapsed ? "xl:ml-[92px]" : "xl:ml-[292px]"
          }`}
        >
          <div className="flex flex-col h-full">
            <div className="flex items-center pt-4 px-2 xl:hidden">
              <button
                onClick={() => setOpen(true)}
                className="flex items-center justify-center h-10 w-10 rounded-lg text-ink hover:bg-surface-hover transition-colors"
              >
                <MdMenu className="h-5 w-5" />
              </button>
            </div>
            <div className="flex-1 p-2 md:pr-2">
              <Routes>
                {getRoutes(userRoutes)}
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route
                  path="/"
                  element={<Navigate to={defaultPath} replace />}
                />
              </Routes>
            </div>
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
}
